/* **************************************************************************
* Composable to facilitate testing (DEV ONLY)
*
* To use: include a 'testState' param in the url set to the desired state
* 
* e.g. /accept-invite?inviteUid=123&senderName=Test%20Sender&testState=NewUserAuthenticated
* e.g. /reset-password?testState=NewPassword
*/ 

import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { useEnvironment } from 'ihunter-pathfinder-components';

const TestStateUser = {
    uid: 'fakeuid',
    displayName: 'Burt Macklin', 
    email: 'fake@insideoutsidestudios.com',
    metadata: {
        createdAt: '1696105476000',
        lastLoginAt: '1748982276000',
    },
    isTestUser: true
};

const testState = ref(null);

export function useTestState() {
    const route = useRoute();
    const { config } = useEnvironment();

    const initializeTestStateFromUrl = (State) => {
        if (config.value.debug) {
            logTestStateOptions(State);
            testState.value = State[route.query.testState];
            if (testState.value) {
                console.log(`Using test state: ${route.query.testState}`);
            } else if (route.query.testState) {
                console.error(`Specified test state '${route.query.testState}' is invalid`);
            } else {
                console.log(`No test state specified`);
            }
        }
    }

    const logTestStateOptions = (State) => {
        if (config.value.debug) {
            const keys = Object.keys(State);
            let msg =`TEST STATE OPTIONS:\n\n`;
            msg += keys.join('\n');
            msg += `\n\nEXAMPLE USAGE:\n?testState=${keys[0]}\n\n`;
            console.log(msg);
        }
    }
    return {
        initializeTestStateFromUrl,
        TestStateUser,
        testState
    };

}